<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import { getUserCompanyList } from '@/common/js/util';
  export default {
    name: 'list',
    mixins: [tableMixins],
    data() {
      return {
        query: {
          accountTypeIn: null,
          accountCodeIn: null,
          postDateEnd: null,
          postDateStart: null,
          reverseFlag: null,
          voucherNo: null,
          entityDataNo: null,
          sapVoucherNo: null,
          companyCodeIn: null,
          reverseSapVoucherNo: null,
          postUserName: null,
          batchNo: null,
          profitCenterCodeIn: null,
        },
        columnListDefault: [
          // {
          //   type: "checkbox",
          //   visible: true,
          //   width: "50",
          //   fixed: "left"
          // },
          /* {
          type: "seq",
          title: "table.index",
          visible: true,
          width: "80"
        }, */
          //外部合同号
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
          {
            field: 'voucherCompanyCode',
            title: '公司代码',
            visible: true,
          },
          {
            field: 'voucherCompanyName',
            title: '公司名称',
            visible: true,
          },
          //业务性质
          {
            field: 'entityDataNo',
            title: '业务单据号',
            visible: true,
          },
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
          {
            field: 'sapVoucherNo',
            title: 'SAP凭证号',
            visible: true,
            width: '180',
          },
          {
            field: 'syncFlagStr',
            title: '同步状态',
            width: '100',
            visible: true,
          },
          {
            field: 'postDate',
            title: '入账日期',
            width: '100',
            visible: true,
          },
          {
            field: 'postUserName',
            title: '过账人员',
            visible: true,
          },
          {
            field: 'voucherDate',
            title: '凭证日期',
            visible: true,
          },
          {
            field: 'reverseFlagStr',
            title: '冲销标识',
            visible: true,
          },
          {
            field: 'reverseDate',
            title: '冲销日期',
            visible: true,
          },
          {
            field: 'natureSideCodeStr',
            title: '借贷方向',
            visible: true,
          },
          {
            field: 'accountTypeStr',
            title: '科目类型',
            visible: true,
          },
          {
            field: 'accountCode',
            title: '科目代码',
            visible: true,
          },
          {
            field: 'accountDesc',
            title: '科目名称',
            visible: true,
          },
          {
            field: 'enteredAmount',
            title: '原币金额',
            visible: true,
          },
          {
            field: 'accountedAmount',
            title: '本币金额',
            visible: true,
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            visible: true,
          },
          {
            field: 'pkCode',
            title: '过账码',
            visible: true,
          },
          {
            field: 'taxCode',
            title: '税码',
            visible: true,
          },
          {
            field: 'assignmentNo',
            title: '分配号',
            visible: true,
          },
          {
            field: 'profitCenterCode',
            title: '利润中心',
            visible: true,
          },
          {
            field: 'profitCenterName',
            title: '利润中心名称',
            visible: true,
          },
          {
            field: 'costCenterCode',
            title: '成本中心',
            visible: true,
          },
          {
            field: 'costCenterName',
            title: '成本中心名称',
            visible: true,
          },
          {
            field: 'cashflowTransactionCode',
            title: '现金流量事务代码',
            visible: true,
          },
          {
            field: 'cashflowTransactionName',
            title: '现金流量事务名称',
            visible: true,
          },
          {
            field: 'currencyCode',
            title: '币种代码',
            visible: true,
          },
          {
            field: 'companyCurrencyCode',
            title: '本币币种代码',
            visible: true,
          },
          {
            field: 'summary',
            title: '摘要',
            visible: true,
          },
          {
            field: 'sglCode',
            title: '特别总账标识代码',
            visible: true,
          },
          {
            field: 'bankAccountNum',
            title: '银行账户号码',
            visible: true,
          },
          {
            field: 'bankName',
            title: '开户行名称',
            visible: true,
          },
          {
            field: 'sapBankCode',
            title: 'SAP开户行编码',
            visible: true,
          },
          {
            field: 'partnerCode',
            title: '合作伙伴编码',
            visible: true,
          },
          {
            field: 'partnerZhName',
            title: '合作伙伴中文名称',
            visible: true,
          },
          {
            field: 'customerCode',
            title: '客户',
            visible: true,
          },
          {
            field: 'supplierCode',
            title: '供应商',
            visible: true,
          },
          {
            field: 'materialCode',
            title: '物料号',
            visible: true,
          },
          {
            field: 'externalCustomerCode',
            title: '外部客户',
            visible: true,
          },
          {
            field: 'maturityDate',
            title: '到期日',
            visible: true,
          },
          {
            field: 'loanNature',
            title: '借款性质',
            visible: true,
          },
          {
            field: 'batchNo',
            title: '批次/评估类型',
            visible: true,
          },
          {
            field: 'businessUnit',
            title: '单位',
            visible: true,
          },
          {
            field: 'orderNo',
            title: '采购销售订单号',
            visible: true,
          },
          {
            field: 'orderDetailNo',
            title: '采购销售行号',
            visible: true,
          },
          {
            field: 'productCategory',
            title: '商品分类',
            visible: true,
          },
          {
            field: 'externalContractNo',
            title: '外部合同号',
            visible: true,
          },
          {
            field: 'invoiceNo',
            title: '发票号',
            visible: true,
          },
          {
            field: 'baseUnit',
            title: '基本计量单位',
            visible: true,
          },
          {
            field: 'payCondition',
            title: '付款条件代码',
            visible: true,
          },
          {
            field: 'paymentMethod',
            title: '付款方式(字典)',
            visible: true,
          },
          {
            field: 'plant',
            title: '工厂',
            visible: true,
          },
          {
            field: 'salesOrderNo',
            title: '销售订单号',
            visible: true,
          },
          {
            field: 'salesOrderItem',
            title: '销售订单行号',
            visible: true,
          },
          {
            field: 'zzboeno',
            title: '外销/购发票/物料号',
            visible: true,
          },
          {
            field: 'contractNo',
            title: '贸易合同号',
            visible: true,
          },
          {
            field: 'downPaymentTrade',
            title: '预付定金交易',
            visible: true,
          },
          {
            field: 'businessQuantity',
            title: '数量',
            visible: true,
          },
          {
            field: 'baseQuantity',
            title: '基本数量',
            visible: true,
          },
          {
            field: 'amountWithoutTax',
            title: '税基金额',
            visible: true,
          },
        ],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'accountTypeIn',
            name: '科目类型',
            type: 'dict',
            dictType: 'accountType',
            placeholder: '请选择科目类型',
            multiple: true,
          },
          // 科目
          {
            prop: 'accountCodeIn',
            name: this.$t('glVoucher.column.accountCode'),
            type: 'dict',
            dictType: 'general_ledger_account',
            placeholder: '请选择科目代码',
            multiple: true,
          },
          {
            prop: 'postDateStart',
            name: '过账日期起',
            type: 'startDaterangePicker',
            placeholder: '请选择过账日期',
          },
          {
            prop: 'postDateEnd',
            name: '过账日期止',
            type: 'endDaterangePicker',
            placeholder: '请选择过账日期',
          },
          {
            prop: 'reverseFlag',
            name: '冲销标识',
            type: 'dict',
            dictType: 'reverseFlag',
            placeholder: '请选择冲销标识',
          },
          {
            prop: 'batchNo',
            name: '批次/评估类型',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入批次号/评估类型',
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入凭证号',
          },
          {
            prop: 'entityDataNo',
            name: '业务单据号',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入业务单据号',
          },
          {
            prop: 'sapVoucherNo',
            name: 'SAP凭证号',
            type: 'input',
            maxlength: 30,
            placeholder: '请输入SAP凭证号',
          },
          {
            type: 'selectMultiple', // 公司：操作人账户下公司
            name: this.$t('contractAgency.company'),
            prop: 'companyCodeIn',
            options: getUserCompanyList(),
          },
          {
            prop: 'reverseSapVoucherNo',
            name: this.$t('glVoucher.column.reverseVoucherNo'),
            type: 'input',
            maxlength: 30,
          },
          {
            prop: 'postUserName',
            name: '过账人员',
            type: 'input',
            maxlength: 30,
          },
          {
            prop: 'profitCenter',
            type: 'searchTableSpec',
            name: '利润中心名称',
            searchType: 'sapProfitCenter',
            extraData: {},
            isNeedMultipleValue: true,
          },
        ];
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.load = true;
        let params = {
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
          ...this.query,
        };
        if (this.query.profitCenter) {
          params.profitCenterCodeIn = this.query.profitCenter.map((item) => {
            return item.profitCenterCode;
          });
        }
        this.$axios
          .post('/financial/tAeVoucherHeaderTemplate/queryReportByPage', params)
          .then((res) => {
            this.load = false;
            this.tableData = res.data.data.list;
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          });
      },

      //重置
      resetBtnClick() {
        //删除已经存在的字段
        delete this.query.contractCategory;
        delete this.query.pageSize;
        delete this.query.pageNum;
        delete this.query.orderByDesc;

        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.tableData = [];
        this.$refs.siruiTable.reloadTable(this.tableData);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
    },
  };
</script>

<style scoped></style>
